export default "__VITE_ASSET__hNvcHkbh__"